/** Bound the tracking aim to nearby road geometry even on very long rides. */
export function chaseLookAheadFraction(routeKilometers: number, zoomOffset: number): number {
  const fraction = routeKilometers > 0 ? Math.min(0.035, 0.15 / routeKilometers) : 0;
  return fraction / 2 ** zoomOffset;
}

/** Chase remains a street-level treatment; UAV uses the whole-route fit. */
export function chaseReferenceZoom(routeTrackingZoom: number): number {
  return Math.min(16, Math.max(15, routeTrackingZoom + 0.65));
}
